import { Lock } from 'lucide-react'

/**
 * A field that shows a value you cannot change — greyed, and carrying a padlock
 * so "locked" looks the same wherever it appears (the Combobox already shows one
 * in its disabled state).
 *
 * ⚠️ FIELD_RO is its OWN class string, never `${FIELD} bg-slate-100 …`. Tailwind
 * resolves same-specificity conflicts by the order utilities are emitted into the
 * stylesheet, not by the order they appear in the class attribute, and the base
 * FIELD's `bg-white` / `text-slate-800` are emitted AFTER `bg-slate-100` /
 * `text-slate-500` — so appending the greys did nothing at all, and three fields
 * in this app rendered as normal white editable inputs for months. Measured in
 * the built CSS 2026-08-19; see docs/CONVENTIONS.md.
 *
 * No focus ring either: a field that cannot take input should not advertise focus.
 */
export const FIELD_RO = 'w-full rounded-xl border border-slate-200 bg-slate-100 px-3 py-2 pr-9 text-[13.5px] text-slate-500 placeholder:text-slate-400 outline-none cursor-not-allowed'

export default function LockedInput({ value, placeholder, type, title }) {
  return (
    <div className="relative" title={title}>
      <input
        value={value ?? ''} placeholder={placeholder} type={type}
        readOnly disabled tabIndex={-1}
        className={FIELD_RO}
      />
      <Lock size={13} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
    </div>
  )
}
